module.exports = __webpack_public_path__ + "static/img/about_civilization_01_zh.1aaa13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_civilization_01_zh.png
// module id = K9ZI
// module chunks = 34